"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = withFormGroup;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _setComponentDisplayName = _interopRequireDefault(require("../helpers/setComponentDisplayName"));

var _storedValuesDidChange = _interopRequireDefault(require("./helpers/storedValuesDidChange"));

var _serializeFormValues = _interopRequireDefault(require("./helpers/serializeFormValues"));

var _evaluateAllControlsValidity = _interopRequireDefault(require("./helpers/evaluateAllControlsValidity"));

var _serializeFormValueValidity = _interopRequireDefault(require("./helpers/serializeFormValueValidity"));

var _initControls = _interopRequireDefault(require("./helpers/initControls"));

var _initState = _interopRequireDefault(require("./helpers/initState"));

var _initStoredValuesFromControls = _interopRequireDefault(require("./helpers/initStoredValuesFromControls"));

var _serializeControlToStoredValue = _interopRequireDefault(require("./helpers/serializeControlToStoredValue"));

var _stateQueue = _interopRequireDefault(require("../helpers/stateQueue"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function withFormGroup(WrappedComponent) {
  var FormGroup = /*#__PURE__*/function (_Component) {
    (0, _inherits2["default"])(FormGroup, _Component);

    var _super = _createSuper(FormGroup);

    function FormGroup(props) {
      var _this;

      (0, _classCallCheck2["default"])(this, FormGroup);
      _this = _super.call(this, props);
      _this.state = (0, _initState["default"])(props);
      _this.displayName = (0, _setComponentDisplayName["default"])(WrappedComponent, props.classPrefixOverride);
      _this.stateQueue = _this.stateQueue || new _stateQueue["default"](_this.handleStateQueue.bind((0, _assertThisInitialized2["default"])(_this)), _serializeControlToStoredValue["default"]);
      _this.reportControlValues = _this.reportControlValues.bind((0, _assertThisInitialized2["default"])(_this));
      _this.reportFormValues = props.reportFormValues.bind((0, _assertThisInitialized2["default"])(_this));
      return _this;
    }

    (0, _createClass2["default"])(FormGroup, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var formData = this.props.formData;

        if (formData && formData.length > 0) {
          this.initStoredValues((0, _initControls["default"])(formData));
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps, prevState) {
        var _this$state = this.state,
            isValid = _this$state.isValid,
            storedValues = _this$state.storedValues;
        var _this$props = this.props,
            formData = _this$props.formData,
            resetForm = _this$props.resetForm;

        if (prevProps.formData !== formData) {
          this.initStoredValues((0, _initControls["default"])(formData));
        }

        if (prevProps.resetForm !== resetForm) {
          this.initStoredValues((0, _initControls["default"])(formData));
        }

        if (prevState.isValid !== isValid) {
          this.reportFormValues({
            isValid: (0, _evaluateAllControlsValidity["default"])(this.state),
            values: (0, _serializeFormValues["default"])(this.state),
            controlValidity: (0, _serializeFormValueValidity["default"])(this.state)
          });
        }

        if ((0, _storedValuesDidChange["default"])(prevState.storedValues, storedValues)) {
          this.reportFormValues({
            isValid: (0, _evaluateAllControlsValidity["default"])(this.state),
            values: (0, _serializeFormValues["default"])(this.state),
            controlValidity: (0, _serializeFormValueValidity["default"])(this.state)
          });
        }
      }
    }, {
      key: "initStoredValues",
      value: function initStoredValues(controls) {
        this.setState({
          isValid: false,
          controls: controls,
          storedValues: (0, _initStoredValuesFromControls["default"])(controls)
        });
      }
    }, {
      key: "handleStateQueue",
      value: function handleStateQueue(storedValues) {
        var prevStoredValues = this.state.storedValues;
        var onQueueComplete = this.props.onQueueComplete;
        var formData = {
          storedValues: _objectSpread(_objectSpread({}, prevStoredValues), storedValues)
        };
        var isValid = (0, _evaluateAllControlsValidity["default"])(formData);
        this.setState(_objectSpread(_objectSpread({}, formData), {}, {
          isValid: isValid
        }), function () {
          return onQueueComplete && onQueueComplete();
        });
      }
    }, {
      key: "reportControlValues",
      value: function reportControlValues(controlState) {
        this.stateQueue.add(controlState);
      }
    }, {
      key: "render",
      value: function render() {
        var controls = this.state.controls;
        var _this$props2 = this.props,
            controlsRendererMap = _this$props2.controlsRendererMap,
            validateControls = _this$props2.validateControls,
            resetForm = _this$props2.resetForm;
        var extraProps = {
          controls: controls,
          controlsRendererMap: controlsRendererMap,
          reportControlValues: this.reportControlValues,
          validateControls: validateControls,
          resetForm: resetForm
        };
        return /*#__PURE__*/_react["default"].createElement(WrappedComponent, (0, _extends2["default"])({}, extraProps, this.props));
      }
    }]);
    return FormGroup;
  }(_react.Component);

  FormGroup.propTypes = {
    formData: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
    classPrefixOverride: _propTypes["default"].string,
    reportFormValues: _propTypes["default"].func.isRequired,
    controlsRendererMap: _propTypes["default"].shape({}),
    validateControls: _propTypes["default"].string,
    onQueueComplete: _propTypes["default"].func.isRequired,
    resetForm: _propTypes["default"].string
  };
  FormGroup.defaultProps = {
    classPrefixOverride: '',
    controlsRendererMap: {},
    validateControls: undefined,
    resetForm: undefined
  };
  return FormGroup;
}